<template>
  <v-col cols="12">
    <v-card>
      <v-card-title>
        {{$t('general.conversationStatus')}}

        <v-spacer/>

        <v-menu :close-on-content-click="false"
                v-model="showMenu">
          <template v-slot:activator="{ on }">
            <v-btn outlined
                   rounded
                   v-on="on">
              Opciones
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              Selecciona los estados
            </v-card-title>

            <v-card-text>
              <v-checkbox color="#2dce98"
                          hide-details
                          :key="stage.description"
                          :label="stage.description"
                          v-for="stage in showStages"
                          v-model="stage.show">
              </v-checkbox>
            </v-card-text>

            <v-card-actions>
              <v-btn block
                     @click="showMenu = false"
                     color="#2dce98"
                     dark>
                Actualizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-card-title>

      <v-card-text class="justify-center" ref="containerFunnel">
        <v-row v-if="selectedAdvisor || !funnelData || funnelData.conversationsByStage.length === 0">
          <v-col cols="12" class="text-center">
            <v-icon class="mb-3"
                    color="warning"
                    size="40">
              error
            </v-icon>
            <br>
            {{$t('general.noDataAvailable')}}
          </v-col>
        </v-row>

        <v-row align="center" justify="center" v-else>
          <vue-funnel-graph :width="width"
                            :height="height"
                            :labels="labels"
                            :values="values"
                            :colors="colors"
                            :direction="direction"
                            :gradient-direction="gradientDirection"
                            :animated="true"
                            :display-percentage="false">
          </vue-funnel-graph>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { VueFunnelGraph } from 'vue-funnel-graph-js'
import { mapState } from 'vuex'
export default {
  components: { VueFunnelGraph },
  computed: {
    ...mapState({
      funnelData: state => state.conversations.funnelData
    })
  },
  mounted () {
    // set width because the component isn't responsive
    let w = this.$refs.containerFunnel.getBoundingClientRect().width
    if (w > 1200 && w < 1600) w = w - 200
    this.width = w - (w * 30 / 100)
  },
  created () {
    if (this.funnelData && this.funnelData.conversationsByStage && this.funnelData.conversationsByStage.length > 0) this.setChartValues()
  },
  data () {
    return {
      labels: ['Saludo inicial'],
      values: [1],
      colors: ['#fb6340', '#36a2eb'],
      direction: 'vertical',
      gradientDirection: 'vertical',
      height: 0,
      showStages: [],
      showMenu: false,
      width: 0
    }
  },
  methods: {
    setChartValues () {
      const labels = []
      const values = []

      let { conversationsByStage, ended } = this.funnelData

      this.height = 75 * (conversationsByStage.length + 1)

      conversationsByStage = [...conversationsByStage]

      const endStage = ended.find(item => {
        return item.description === conversationsByStage[conversationsByStage.length - 1].description
      })

      if (endStage) conversationsByStage.push({ description: 'Conversación finalizada', count: endStage.count })

      conversationsByStage.forEach((item, index) => {
        if (this.showStages[index].show) {
          labels.push(item.description)
          values.push(item.count)
        }
      })

      this.labels = labels
      this.values = values
    }
  },
  props: ['selectedAdvisor'],
  watch: {
    funnelData () {
      this.showStages = []

      this.funnelData.conversationsByStage.forEach(stage => {
        this.showStages.push({
          description: stage.description,
          show: true
        })
      })

      this.showStages.push({
        description: 'Conversación finalizada',
        show: true
      })

      this.setChartValues()
    },
    selectedAdvisor (value) {
      if (!value) this.setChartValues()
    },
    showMenu (value) {
      if (!value) {
        this.setChartValues()
      }
    }
  }
}
</script>

<style>
.svg-funnel-js .label__title {
  color: #163974 !important;
}

.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__label:not(:first-child) {
  border-top: 1px dashed black;
}

</style>
